import { ProductSalesModel } from 'api-hooks/product/sales';
import { Option } from 'baseui/select';
import * as Yup from 'yup';

export const ProductSaleDetailFormSchema = () =>
  Yup.object({
    productVariantId: Yup.object({
      id: Yup.string().default(''),
      label: Yup.string().default(''),
    }),
    price: Yup.number().default(0),
    qty: Yup.number().default(0).min(1),
    description: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    stock: Yup.number(),
  });

export const ProductSaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    productSales: Yup.array(ProductSaleDetailFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type ProductSaleFormType = Yup.InferType<
  ReturnType<typeof ProductSaleFormSchema>
> & {
  productSale?: ProductSalesModel;
  customerBillingOptions: Option[];
};

export type ProductSaleDetailFormType = Yup.InferType<
  ReturnType<typeof ProductSaleDetailFormSchema>
>;
